import { cn } from '../utils/cn';

import { LogoInsolitum, type LogoInsolitumProps } from './LogoInsolitum';
import { WYSOKOSC_PODPISU } from './geometria';

/**
 * Podpis „część Insolitum" — logo poziome, nieruchome i stonowane, na dole
 * ekranów, na których główną postacią jest ORGAN (kafel organu, karta
 * odmowy, logowanie do portalu) albo ekran awarii.
 *
 * Jedno miejsce na rozmiar i kolor: pierwsze wdrożenie wpisało
 * `wysokosc={32}` w piętnastu plikach, a 32 px to 119 px szerokości, czyli
 * piksel poniżej minimum z README pakietu. Wysokość podpisu to najmniejsza
 * CAŁA liczba pikseli, przy której logo ma 120 px (`SKALA_ZNAKU.podpis`).
 *
 * `stopka` — podpis w przepływie, przyciśnięty do dołu ekranu
 * (`<footer class="ids-podpis-stopka">`, `margin-top: auto`). Rodzic to
 * kolumna flex o wysokości ekranu z dolnym odstępem `--ids-s6`; podpis stoi
 * wtedy zawsze 24 px od dołu, a na niskim ekranie NIE wchodzi na treść
 * (w odróżnieniu od `position: absolute`).
 *
 * Gdy sygnet stoi już w tym samym widoku (EkranBledu z domyślną ilustracją),
 * podpisem jest sam napis — README pakietu: dwa sygnety w jednym widoku to
 * o jeden za dużo. Tamten przypadek rozstrzyga `EkranBledu`, nie ten komponent.
 *
 * Komponent serwerowy (bez hooków) — import przez subścieżkę
 * `@insolitum/ui/marka/PodpisInsolitum` także w plikach serwerowych Next.
 */
export { WYSOKOSC_PODPISU };

export interface PodpisInsolitumProps extends Omit<
  LogoInsolitumProps,
  'uklad' | 'wysokosc' | 'uproszczony'
> {
  /** Owija podpis w stopkę przyciśniętą do dołu kolumny (`.ids-podpis-stopka`). */
  stopka?: boolean;
}

export function PodpisInsolitum({ className, stopka = false, ...props }: PodpisInsolitumProps) {
  const logo = (
    <LogoInsolitum
      uklad="poziome"
      wysokosc={WYSOKOSC_PODPISU}
      className={cn('ids-podpis', className)}
      {...props}
    />
  );
  return stopka ? <footer className="ids-podpis-stopka">{logo}</footer> : logo;
}
